// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p{margin-top:16px}ul,ol{padding-left:16px}", "",{"version":3,"sources":["webpack://./src/css/cookies.scss"],"names":[],"mappings":"AAAA,EACI,eAAA,CAGJ,MAEI,iBAAA","sourcesContent":["p {\r\n    margin-top: 16px;\r\n}\r\n\r\nul,\r\nol {\r\n    padding-left: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
